import apiClient from '../apiClient';
import { PUT_CUSTOMER_PROFILE_URL } from '../apiUrl';

const putCustomerProfileApi = (id, data) => {
  return apiClient.put(PUT_CUSTOMER_PROFILE_URL(id), data);
};

export default putCustomerProfileApi;
